import React, { Component, useEffect, useState } from "react";
import * as d3 from "d3";
interface Tooltip {
  x: number;
  y: number;
  index: number;
}
interface Props {
  data: [number, number][];
  tdID: string;
}
function LineChartSmall({ data, tdID }: Props) {
  const [tooltip, setTooltip] = useState<Tooltip | null>(null);

  const labels = ["Q1", "Q2", "Q3", "Q4"];

  useEffect(() => {
    DrawLineChartSmall();
  }, [data]);

  function DrawLineChartSmall() {
    // Widths and margins.

    var graph_width = 60;
    var margin = { top: 5, right: 2, bottom: 5, left: 2 },
      width = graph_width - margin.left - margin.right,
      height = 15 - margin.top - margin.bottom;

    // X and Y scales.
    var y = d3.scaleLinear().domain([0, height]).range([height, 0]);

    const x = d3.scaleBand().domain(labels).range([0, width]);

    d3.select(".air-quality" + tdID)
      .select("svg")
      .remove();
    // Construct our SVG object.
    var svg = d3
      .select(".air-quality" + tdID)
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    // Line functions.

    // X-axis.
    var xAxis = d3.axisBottom(x);

    var yAxis = d3.axisLeft(y);

    var maxYscale = 0;
    var max = 0;
    for (var i = 0; i < data.length; i++) {
      if (max < data[i][1]) {
        max = data[i][1];
      }
    }
    var min = max;
    for (var i = 0; i < data.length; i++) {
      if (min > data[i][1]) {
        min = data[i][1];
      }
    }
    y.domain([min - 5, max + 5]);

    // Width of bars, without padding.
    var barRawWidth = width / labels.length;
    var barPadding = 0; // * labels.length;
    var xStart = barPadding + barRawWidth / 2;

    // Update x scale function. /
    //x.range([xStart, width-xStart]);

    xAxis.scale(x);
    yAxis.scale(y);
    var lineInlet = d3
      .line()
      .y(function (d) {
        return y(d[1]);
      })
      .x((d) => ((x(labels[d[0] - 1]) || 0) + xStart) | 0);

    // Update x-axis.
    //    svg.append("g")
    //    .attr("class", "x axis")
    //  .attr("transform", "translate(0," + height + ")")
    // .call(xAxis);
    //svg.append("g")
    //.attr("class", "y axis")
    //.call(yAxis);

    var inlet = svg
      .append("path")
      .attr("d", lineInlet(data))
      .attr("stroke", "#ccc")
      .attr("stroke-width", "1")
      .attr("strokeLinecap", "round")
      .attr("fill", "none")
      .style("opacity", 1e-6)
      .transition()
      .duration(1000)
      .style("opacity", 1.0)
      .style("stroke-width", "1");
    ////
    for (var i = 0; i < data.length; i++) {
      var circle = svg
        .append("circle")

        .attr("stroke", "none")
        .attr("stroke-width", "3")
        .attr("strokeLinecap", "round")
        .attr("fill", "#ccc")
        .attr("cx", ((x(labels[data[i][0] - 1]) || 0) + xStart) | 0)
        .attr("cy", y(data[i][1]))
        .attr("r", "3");
    }

    // Add mouseover events.

    svg
      .on("mouseover", function () {})
      .on("mousemove", function (event) {
        var xPos = event.clientX;
        var domain = x.domain();
        var range = x.range();
        var rangePoints = d3.range(range[0], range[1], x.step());

        var firstaxis = svg.node() || null;
        if (firstaxis != null) {
          var anyother = firstaxis.getBoundingClientRect();
          const offsetX = xPos - anyother.left - margin.left + 5;

          var domain = x.domain();
          var range = x.range();
          var rangePoints = d3.range(range[0], range[1], x.step());
          var yPos = domain[d3.bisect(rangePoints, offsetX) - 1];
          var xAxisDataIndex = d3.bisect(rangePoints, offsetX) - 1;
          var tableBody = document.getElementById("BodyToolTip" + tdID);

          if (tableBody != null) {
            while (tableBody.hasChildNodes()) {
              tableBody.removeChild(tableBody.children[0]);
            }
          }
          var tr = document.createElement("tr");

          var td = document.createElement("td");
          td.innerHTML = labels[xAxisDataIndex];
          tr.append(td);
          var td2 = document.createElement("td");
          td2.innerHTML = String(data[xAxisDataIndex][1]);
          tr.append(td2);
          if (tableBody != null) tableBody.append(tr);

          setTooltip({
            x: event.clientX,
            y: event.clientY,
            index: xAxisDataIndex,
          });
        }
      })
      .on("mouseout", function () {
        setTooltip(null);
      });
  }
  return (
    <div className={"air-quality" + tdID}>
      {tooltip !== null ? (
        <div className="tooltip" style={{ top: tooltip.y, left: tooltip.x }}>
          <span className="tooltip__title">{labels[tooltip.index]}</span>
          <table className="">
            <tbody id={"BodyToolTip" + tdID}></tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}

export default LineChartSmall;
